@if (isBlocked()) {
  <section class="fixed inset-0 z-[110] flex min-h-screen flex-col items-center justify-center bg-slate-950/95 px-4 py-8 backdrop-blur-sm">
    <div class="flex w-full max-w-sm flex-col items-center rounded-3xl bg-white px-8 py-10 text-center shadow-xl">
      <img [src]="imageEnum.ALERT_CIRCLE" alt="" class="h-12 w-12" />
      <h1 class="heading mt-4">Exam open in another tab</h1>
      <p class="sub-paragraph mt-3 text-text-secondary">
        Your test is already running in another tab or window. Multiple tabs are not allowed during the test —
        please close this tab and continue in the original one.
      </p>
      @if (closeFailed()) {
        <p class="sub-paragraph mt-4 text-red-600">This tab could not be closed automatically. Please close it manually.</p>
      }
      <div class="mt-6 w-full">
        <app-primary-button text="Close This Tab" (buttonClick)="closeTab()" />
      </div>
    </div>
  </section>
}
